var map = {
	"./calendar-alert-outline.png": 199,
	"./calendar-alert-outline.svg": 88,
	"./calendar-check-outline.png": 69,
	"./calendar-check-outline.svg": 933,
	"./calendar-month-outline.png": 159,
	"./calendar-month-outline.svg": 675,
	"./calendar-today-outline.png": 522,
	"./calendar-today-outline.svg": 309,
	"./calendar-week-outline.png": 987,
	"./calendar-week-outline.svg": 116,
	"./note-edit-outline.png": 717,
	"./reminder.png": 427,
	"./trash-can-outline.png": 771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;